export const Filter =
{
	ALL: "10",
	SANITARY : "1",
	RAIN_WATER : "2",
	WASTED_WATER : "3",
	FAN_COILS : "4",
	AQUADUCT : "5",
	THERMACTIF : "6",
	ACOSI : "7",
	DUANCE : "8",
	AIR: "9",
	AXELAIR: "11",
	JETLY: "12",
	PBTUB: "13",
	SFERACO: "14",
	THERMACOME: "15",
	THERMADOR: "16"
}

export const SceneStates = {
	LOADER: "loader",
	INTRO: "Intro",
	CUVE_ALCOOL: "cuve_alcool",
	CUVE_REACTEUR: "cuve_reacteur",
	END_SESSION: "end_session",
};
